import { InternalShipmentGroup, ShipmentGroupConfiguration, ShipmentGroup, ShipmentGroupOptions } from '../../models/shipment-group';
import { createTokenizer } from '../functions';

export const internalShipmentGroupTokenizer = createTokenizer('carrierAccountKey', 'tag');

export function createShipmentGroupMap(
  shipmentGroupConfigurations: Record<string, ShipmentGroupConfiguration>,
) {
  const shipmentGroupConfigurationMap = new Map<string, ShipmentGroupConfiguration>();
  for (const shipmentGroupConfiguration of Object.values(shipmentGroupConfigurations)) {
    for (const carrierAccountKey of shipmentGroupConfiguration.carrierAccountKeys) {
      shipmentGroupConfigurationMap.set(
        internalShipmentGroupTokenizer({ carrierAccountKey, tag: shipmentGroupConfiguration.tag }),
        shipmentGroupConfiguration,
      );
    }
  }
  return shipmentGroupConfigurationMap;
}

export function generateShipmentGroups(
  internalShipmentGroups: Record<string, InternalShipmentGroup>,
  shipmentGroupConfigurationMap: Map<string, ShipmentGroupConfiguration>,
) {
  const shipmentGroups: Record<string, ShipmentGroup> = {};
  let unsortedShipmentCount = 0;
  let sortedShipmentCount = 0;
  for (const internalShipmentGroup of Object.values(internalShipmentGroups)) {
    const {
      id,
      carrierAccountKey,
      carrierAccountName,
      tag,
      shipmentCount,
      palletBoxes,
    } = internalShipmentGroup;
    const internalShipmentGroupId = internalShipmentGroupTokenizer(internalShipmentGroup);
    const shipmentGroupConfiguration = shipmentGroupConfigurationMap.get(internalShipmentGroupId);
    if (shipmentGroupConfiguration) {
      if (!shipmentGroups[shipmentGroupConfiguration.id]) {
        shipmentGroups[shipmentGroupConfiguration.id] = {
          shipmentCount,
          tag,
          id: shipmentGroupConfiguration.id,
          name: shipmentGroupConfiguration.name,
          palletBoxes: [...palletBoxes],
          pinned: shipmentGroupConfiguration.pinned,
          option: shipmentGroupConfiguration.option,
          internalShipmentGroups: [{
            id,
            shipmentCount,
            key: carrierAccountKey,
            name: carrierAccountName,
          }],
          manualLoadDisabled: !!shipmentGroupConfiguration.manualLoadDisabled,
        };
      } else {
        shipmentGroups[shipmentGroupConfiguration.id].shipmentCount += shipmentCount;
        shipmentGroups[shipmentGroupConfiguration.id].palletBoxes.push(...palletBoxes);
        shipmentGroups[shipmentGroupConfiguration.id].internalShipmentGroups.push({
          id,
          shipmentCount,
          key: carrierAccountKey,
          name: carrierAccountName,
        });
      }
    } else {
      shipmentGroups[id] = {
        id,
        tag,
        shipmentCount,
        palletBoxes: [...palletBoxes],
        name: carrierAccountName,
        pinned: true,
        option: ShipmentGroupOptions.DEFAULT,
        internalShipmentGroups: [{
          id,
          shipmentCount,
          key: carrierAccountKey,
          name: carrierAccountName,
        }],
        manualLoadDisabled: false,
      };
    }
    unsortedShipmentCount += shipmentCount;
    sortedShipmentCount += palletBoxes.reduce((acc, cur) => acc + cur.shipmentCount, 0);
  }

  return {
    unsortedShipmentCount,
    sortedShipmentCount,
    shipmentGroups,
  };
}
